import { HTTP } from "./http";

let API_SERVER = "";

if (window.location.href.indexOf("8080") > -1) {
  API_SERVER =
    "http://www.localhost:8888/back-end-endpoint-stripe-connect.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-stripe-connect.php";
}

const StripeConnect = {
  find(params) {
    return HTTP.post(API_SERVER, params);
  },

  getConnectStatus(clubId) {
    return this.find({ action: "getConnectStatus", clubId });
  },

  createOnboardingLink(clubId, email) {
    return this.find({ action: "createOnboardingLink", clubId, email });
  },

  listFeePlans(clubId, includeInactive = false) {
    return this.find({ action: "listFeePlans", clubId, includeInactive });
  },

  saveFeePlan(plan) {
    return this.find({ action: "saveFeePlan", ...plan });
  },

  deactivateFeePlan(clubId, planId) {
    return this.find({ action: "deactivateFeePlan", clubId, planId });
  },

  createFeeCheckout(payload) {
    return this.find({ action: "createFeeCheckout", ...payload });
  },

  /** Public, signed by the deposit link: start a Stripe Checkout for a trial deposit. */
  createTrialDepositCheckout(clubId, trialRegistrationId, t, email) {
    return this.find({ action: "createTrialDepositCheckout", clubId, trialRegistrationId, t, email });
  },

  confirmCheckoutSession(clubId, sessionId) {
    return this.find({ action: "confirmCheckoutSession", clubId, sessionId });
  },

  getMembersPaymentStatus(clubId) {
    return this.find({ action: "getMembersPaymentStatus", clubId });
  },

  getMemberPaymentHistory(clubId, userId) {
    return this.find({ action: "getMemberPaymentHistory", clubId, userId });
  },

  saveCampaign(campaign) {
    return this.find({ action: "saveCampaign", ...campaign });
  },

  setCampaignStatus(clubId, campaignId, status) {
    return this.find({ action: "setCampaignStatus", clubId, campaignId, status });
  },

  listCampaigns(clubId) {
    return this.find({ action: "listCampaigns", clubId });
  },

  // Member-facing: only ACTIVE campaigns targeted at this user's team(s).
  getMemberCampaigns(clubId, userId) {
    return this.find({ action: "getMemberCampaigns", clubId, userId });
  },

  getCampaignDonations(clubId, campaignId) {
    return this.find({ action: "getCampaignDonations", clubId, campaignId });
  },

  getPublicCampaign(clubId, campaignId) {
    return this.find({ action: "getPublicCampaign", clubId, campaignId });
  },

  createDonationCheckout(payload) {
    return this.find({ action: "createDonationCheckout", ...payload });
  },

  confirmDonation(clubId, sessionId) {
    return this.find({ action: "confirmDonation", clubId, sessionId });
  },

  getMemberPaymentLink(clubId, feePlanId, userId) {
    return this.find({ action: "getMemberPaymentLink", clubId, feePlanId, userId });
  },

  emailPaymentLinks(clubId, feePlanId, userIds) {
    return this.find({ action: "emailPaymentLinks", clubId, feePlanId, userIds });
  },

  refundPayment(clubId, recordId) {
    return this.find({ action: "refundPayment", clubId, recordId });
  },

  createBillingPortalLink(clubId, userId) {
    return this.find({ action: "createBillingPortalLink", clubId, userId });
  },

  cancelSubscription(clubId, recordId, immediately = false) {
    return this.find({
      action: "cancelSubscription",
      clubId,
      recordId,
      immediately,
    });
  },

  recordManualPayment(payload) {
    return this.find({ action: "recordManualPayment", ...payload });
  },

  // -- Installment plans (AU season fees) + sports vouchers ----------------

  getInstallmentStatus(clubId, userId, feePlanId) {
    return this.find({ action: "getInstallmentStatus", clubId, userId, feePlanId });
  },

  // Player-facing: the current player's own season fees (finds their
  // installment account, returns ledger + voucher state).
  getMyInstallmentStatus(clubId, userId) {
    return this.find({ action: "getMyInstallmentStatus", clubId, userId });
  },

  createInstallmentCheckout(clubId, userId, feePlanId, installmentId) {
    return this.find({
      action: "createInstallmentCheckout",
      clubId,
      userId,
      feePlanId,
      installmentId,
    });
  },

  createInstallmentCheckoutByEmail(clubId, email, feePlanId, installmentId) {
    return this.find({
      action: "createInstallmentCheckout",
      clubId,
      email,
      feePlanId,
      installmentId,
    });
  },

  getPublicInstallmentStatus(clubId, email, feePlanId = null) {
    return this.find({
      action: "getPublicInstallmentStatus",
      clubId,
      email,
      feePlanId,
    });
  },

  recordInstallmentPayment(payload) {
    return this.find({ action: "recordInstallmentPayment", ...payload });
  },

  claimVoucher(payload) {
    return this.find({ action: "claimVoucher", ...payload });
  },

  listVoucherClaims(clubId, status = null) {
    return this.find({ action: "listVoucherClaims", clubId, status });
  },

  decideVoucher(clubId, discountId, decision) {
    return this.find({ action: "decideVoucher", clubId, discountId, decision });
  },

  markVouchersRedeemed(clubId, discountIds) {
    return this.find({ action: "markVouchersRedeemed", clubId, discountIds });
  },

  waiveFees(clubId, userId, note) {
    return this.find({ action: "waiveFees", clubId, userId, note });
  },

  deleteFeeRecord(clubId, recordId) {
    return this.find({ action: "deleteFeeRecord", clubId, recordId });
  },

  refreshMemberStatuses(clubId) {
    return this.find({ action: "refreshMemberStatuses", clubId });
  },
};

export { StripeConnect };
